// extracted by mini-css-extract-plugin
export var avatarContainer = "_c7-0";
export var avatarTypingWave = "_c7-i";
export var gray = "_c7-f";
export var green = "_c7-c";
export var icon = "_c7-9";
export var image = "_c7-1";
export var lg = "_c7-6";
export var md = "_c7-5";
export var presenceDot = "_c7-b";
export var red = "_c7-d";
export var sm = "_c7-4";
export var status = "_c7-a";
export var typingDot = "_c7-h";
export var typingPill = "_c7-g";
export var xl = "_c7-7";
export var xs = "_c7-3";
export var xxl = "_c7-8";
export var xxs = "_c7-2";
export var yellow = "_c7-e";